var _polygon, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610.07 389.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "313.51 71 353.74 152.51 443.69 165.58 378.6 229.03 393.97 318.62 313.51 276.32 233.05 318.62 248.42 229.03 183.33 165.58 273.28 152.51 313.51 71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "vol50",
    d: "M153.24,73.11a181.91,181.91,0,0,0,0,257.39",
    transform: "translate(-8.49 -9.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "vol100",
    d: "M91,10.89C-15.69,117.59-15.69,290.27,91,397",
    transform: "translate(-8.49 -9.12)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "vol50",
    d: "M473.81,334.74a181.89,181.89,0,0,0,0-257.38",
    transform: "translate(-8.49 -9.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "vol100",
    d: "M536,397c106.7-106.7,106.7-279.38,0-386.08",
    transform: "translate(-8.49 -9.12)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSound);
export default __webpack_public_path__ + "static/media/star-sound.2f47b820131d33c46a20764dae6f489d.svg";
export { ForwardRef as ReactComponent };